module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "OrderTracking",
    attrs: {
      "id": "OrderTracking"
    }
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-image": "url('../../../../static/assets/include/svg/svg-bg1.svg')",
      "background-attachment": "fixed"
    }
  }, [_c('div', {
    staticClass: "container-fluid g-py-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "page-title"
  }, [_vm._v("Track Orders & History")]), _vm._v(" "), _c('p', {
    staticClass: "text-center g-pt-40"
  }, [_vm._v("\n                              To see the full order details, please click on the E-Order #. "), _c('br'), _vm._v("To change, edit,\n                              or cancel a submitted order, please "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("click here")]), _vm._v(" to contact us.\n                          ")]), _vm._v(" "), _c('order-tracking-filters', {
    attrs: {
      "OrderList": _vm.OrderList,
      "DispenseList": _vm.DispenseList,
      "SearchObject": _vm.SearchObject,
      "PageValues": _vm.PageValues,
      "isDataLoading": _vm.isDataLoading,
      "searchValue": _vm.searchValue,
      "statusFilter": _vm.statusFilter,
      "statusString": _vm.statusString
    },
    on: {
      "search": function($event) {
        return _vm.GetOrderTableData(0)
      },
      "reset": function($event) {
        return _vm.Reset()
      },
      "clicked": function($event) {
        return _vm.GetOrderTableData(0)
      },
      "update:DispenseList": function($event) {
        _vm.DispenseList = $event
      },
      "update:dispense-list": function($event) {
        _vm.DispenseList = $event
      }
    }
  }), _vm._v(" "), _c('order-tracking-table', {
    attrs: {
      "SortValues": _vm.SortValues,
      "OrderList": _vm.OrderList,
      "DispenseList": _vm.DispenseList,
      "PageValues": _vm.PageValues,
      "isDataLoading": _vm.isDataLoading,
      "MasterAccountType": _vm.MasterAccountType
    },
    on: {
      "sort": function($event) {
        return _vm.GetOrderTableData(0)
      },
      "delete": function($event) {
        return _vm.GetOrderTableData(0)
      },
      "update:DispenseList": function($event) {
        _vm.DispenseList = $event
      },
      "update:dispense-list": function($event) {
        _vm.DispenseList = $event
      }
    }
  })], 1)])])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b3b53f0e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3b53f0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/OrderTracking/OrderTracking.vue
// module id = 541
// module chunks = 3